import { ChevronLeftIcon, FileTextIcon, IdCardIcon } from "@radix-ui/react-icons";
import { Button, Flex } from "@radix-ui/themes";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../hooks/hooks";
import { setPdfPreviewType } from "../../redux/slices/report/report";
import { resetUpdateEnrollmentData } from "../../redux/slices/school/student";
import { resetUserData } from "../../redux/slices/users/user";
import { routes } from "../../routes";
import { UserPreview } from "../Users/UserPreview";
import { useLogoBase64 } from "../../hooks/useLogoBase64";
import { useExportDocument } from "../../hooks/useExportDocument";
import { RegimeOptions } from "../../utils/studentUtils";
import { useIES } from "../../hooks/useIES";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { resetLoaderAvailable, setLoaderAvailable } from "../../redux/slices/loaderController";
import { stringToBoolean } from "../../utils/utilities";
import { isEmpty } from "lodash";

export const PrintEnrollmentDocs = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const {logoBase64} = useLogoBase64();
    const { IES, isLoading } = useIES();
    const userData = useSelector((state: RootState) => state.login.userData)
    const { exportDocumentPdf:exportDocument } = useExportDocument()
    const enrollmentData = useAppSelector((state) => state.student);
    const handleBack = ()=>{
      dispatch(resetUserData());
      dispatch(resetUpdateEnrollmentData());
      navigate(routes.enrollments);
    }
    const handlePrintStudentCard = async() => {
         dispatch(setLoaderAvailable(true)); 
      const data: any = {
        type: "CARTAO_ESTUDANTE",
        outputFormat: "DOCX",
        data: {
             ies:IES.NAME, 
             ano_lectivo:enrollmentData.enrollment.academicYear, 
             nome_completo:enrollmentData.student?.fullname, 
             regime: RegimeOptions[ enrollmentData.enrollment.regime ?? "1"] ?? "",
             codigo:enrollmentData.student?.schoolCode,
             nue:enrollmentData?.student?.studentUniversalCode===enrollmentData.student?.schoolCode?'N/A':enrollmentData.student?.studentUniversalCode,
             curso:enrollmentData.enrollment.course,
            },
            logoBase64: logoBase64 ?? '',
            avatar: enrollmentData.student?.photo ?? '',
       }
      await exportDocument(data, 'CARTAO_ESTUDANTE');
        dispatch(resetLoaderAvailable());
    }
    const handlePrintStudentProcess = async () => {
        dispatch(setLoaderAvailable(true));
        const data: any = {
            type: "STUDENT_PROCESS",
            outputFormat: "DOCX",
            data: {
                ies: IES.NAME,
                ano_lectivo: enrollmentData.enrollment.academicYear,
                nome_completo: enrollmentData.student?.fullname,
                codigo: enrollmentData.student?.schoolCode,
                curso: enrollmentData.enrollment.course,
                data_emissao: new Date().toLocaleDateString(),
                utilizador: userData?.Fullname ?? "",
                cargo: userData?.Role,
                delegacao: enrollmentData.enrollment.faculty ?? "",
            },
            logoBase64: logoBase64 ?? '',
        };
        if (stringToBoolean(enrollmentData.payment?.isPaymentByEntityReference))  {
            data.type = "STUDENT_PROCESS_REFERENCE";
            data.data.valor = enrollmentData.payment?.totalPrice ?? 0;
            data.data.referencia = enrollmentData.payment?.reference ?? "";
            data.data.banco = enrollmentData.payment?.bankName ?? "";
            data.data.entidade = enrollmentData.payment?.entity ?? "";
        }
        await exportDocument(data, 'STUDENT_PROCESS');
        dispatch(resetLoaderAvailable());
    }

    return (
        <>
            <Flex direction='column' gap='4'>
                <UserPreview />

                <Flex gap='4'>
                    <Button type="button" variant="soft" color="gray" onClick={handleBack}>
                        <ChevronLeftIcon /> Voltar
                    </Button>
                    <Button type="button" onClick={handlePrintStudentCard}>
                        <IdCardIcon /> Imprimir cartão de estudante
                    </Button>
                    <Button type="button" onClick={handlePrintStudentProcess}>
                        <FileTextIcon /> Imprimir processo
                    </Button>
                
                </Flex>
            </Flex>
        </>
    )
}

